import { PageHeader } from '@organisms';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { FilterEvents } from './Filter.events';
import { ModalEvents } from './Modal.events';
import { TableEvents } from './Table.events';

export const EventsPage: React.FC = () => {
  useBreadcrumbs([
    {
      label: 'Eventos',
    },
  ]);

  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        backToPath={() => {
          navigate(-1);
        }}
        title={'Gestão de eventos'}
        subTitle={''}
      />

      <TableEvents filterComponent={<FilterEvents />} />

      <ModalEvents title='Gerenciar eventos' />
    </>
  );
};
